/*
 * Field & Fortune – automatic gift offer (cart sync)
 * Buy 1 clothing item  -> The Field & Fortune Cuff (1)
 * Buy 2+ clothing items -> Cuff + The Estate Watch (1 each)
 * The price is removed by the automatic BXGY discounts in Shopify; this script only
 * keeps the gift lines in the cart in step with the qualifying quantity.
 * Config comes from <script type="application/json" id="FFGiftConfig"> (snippets/cart-drawer.liquid).
 */
(function () {
  if (window.FFGift) return;

  var cfgEl = document.getElementById('FFGiftConfig');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var CUFF = Number(cfg.cuff) || 0;
  var WATCH = Number(cfg.watch) || 0;
  if (!CUFF && !WATCH) return;
  var EXCLUDED = (cfg.excluded || []).map(function (t) {
    return String(t).trim().toLowerCase();
  });
  var SOURCE = 'ff-gift';
  var failed = {}; // variant id -> true when Shopify refused the add (e.g. out of stock); not retried this page view
  var running = false;
  var queued = false;

  function r(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }
  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }
  function isGiftLine(item) {
    return (
      item.variant_id === CUFF ||
      item.variant_id === WATCH ||
      (item.properties && (item.properties._gift === 'true' || item.properties._gift === true))
    );
  }
  function qualifyingCount(cart) {
    return cart.items.reduce(function (n, item) {
      if (isGiftLine(item)) return n;
      var type = String(item.product_type || '').trim().toLowerCase();
      if (EXCLUDED.indexOf(type) !== -1) return n;
      return n + item.quantity;
    }, 0);
  }

  // Works out what has to change. Returns { updates: {lineKey: qty}, adds: [...] }
  function plan(cart) {
    var q = qualifyingCount(cart);
    var want = {};
    if (CUFF) want[CUFF] = q >= 1 ? 1 : 0;
    if (WATCH) want[WATCH] = q >= 2 ? 1 : 0;
    var updates = {};
    var adds = [];
    Object.keys(want).forEach(function (vidStr) {
      var vid = Number(vidStr);
      var remaining = want[vid];
      cart.items
        .filter(function (item) {
          return item.variant_id === vid;
        })
        .forEach(function (line) {
          var target = remaining > 0 ? 1 : 0; // never more than 1 of each gift
          if (line.quantity !== target) updates[line.key] = target;
          remaining -= target;
        });
      if (remaining > 0 && !failed[vid]) {
        adds.push({ id: vid, quantity: 1, properties: { _gift: 'true' } });
      }
    });
    return { updates: updates, adds: adds };
  }

  function getCart() {
    return fetch(r('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function refreshUI() {
    var cartPath = r('cart_url', '/cart');
    if (window.location.pathname === cartPath) {
      window.location.reload();
      return;
    }
    // Florence/Dawn: <cart-drawer-items> listens for cart-update events (any source except 'cart-items')
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE });
    }
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function sync() {
    if (running) {
      queued = true;
      return Promise.resolve();
    }
    running = true;
    var changed = false;

    // At most 2 passes per sync: no endless loops even if Shopify refuses a change.
    function pass(n) {
      if (n >= 2) return Promise.resolve();
      return getCart().then(function (cart) {
        var p = plan(cart);
        var hasUpdates = Object.keys(p.updates).length > 0;
        if (!hasUpdates && p.adds.length === 0) return;
        changed = true;
        var step = hasUpdates
          ? jsonPost(r('cart_update_url', '/cart/update') + '.js', { updates: p.updates })
          : Promise.resolve();
        return step
          .then(function () {
            if (!p.adds.length) return;
            return jsonPost(r('cart_add_url', '/cart/add') + '.js', { items: p.adds }).then(function (res) {
              if (!res.ok) {
                // try one by one so one sold-out gift does not block the other
                return p.adds.reduce(function (chain, add) {
                  return chain.then(function () {
                    return jsonPost(r('cart_add_url', '/cart/add') + '.js', { items: [add] }).then(function (res2) {
                      if (!res2.ok) failed[add.id] = true;
                    });
                  });
                }, Promise.resolve());
              }
            });
          })
          .then(function () {
            return pass(n + 1);
          });
      });
    }

    return pass(0)
      .catch(function (e) {
        console.error('[FFGift]', e);
      })
      .then(function () {
        running = false;
        if (changed) refreshUI();
        if (queued) {
          queued = false;
          return sync();
        }
      });
  }

  var timer = null;
  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  window.FFGift = { sync: sync, plan: plan, qualifyingCount: qualifyingCount };

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return; // our own refresh
        scheduleSync();
      });
    }
    scheduleSync(); // catch carts changed elsewhere (other tab, /cart/add links, etc.)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
